<template>
  <div class="rich-text-editor">
    <quill-editor class="editor" :value="value" :options="editorOptions" @input="onInput" />
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'

export default {
  name: 'RichTextEditor',
  components: { quillEditor },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '請輸入內容',
    },
    height: {
      type: String,
      default: '220px',
    },
  },
  data() {
    return {
      editorOptions: {
        theme: 'snow',
        placeholder: this.placeholder,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: [1, 2, 3, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            ['link', 'image', 'video'],
            ['clean'],
          ],
        },
      },
    }
  },
  methods: {
    onInput(html) {
      this.$emit('input', html)
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-text-editor {
  line-height: normal;

  ::v-deep .ql-toolbar {
    border-radius: 4px 4px 0 0;
    border-color: #dcdfe6;
  }

  ::v-deep .ql-container {
    border-radius: 0 0 4px 4px;
    border-color: #dcdfe6;
    font-size: 14px;
  }

  ::v-deep .ql-editor {
    min-height: 220px;
  }
}
</style>
